import { render, staticRenderFns } from "./Handout.vue?vue&type=template&id=173582a8&scoped=true&"
import script from "./Handout.vue?vue&type=script&lang=js&"
export * from "./Handout.vue?vue&type=script&lang=js&"
import style0 from "./Handout.vue?vue&type=style&index=0&id=173582a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173582a8",
  null
  
)

export default component.exports